var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemperature4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 17C41 12.0295 36.9706 8 32 8C27.0295 8 23 12.0295 23 17V36.0638C21.1461 38.1646 20.0156 40.919 20.0002 43.9375C19.9666 50.5284 25.324 55.954 31.9148 55.9997C31.9428 55.9999 31.972 56 32 56C38.628 56 44 50.6278 44 44C44 40.957 42.8668 38.1791 41 36.0638V17ZM32 51.5L31.946 51.4998C27.8342 51.4713 24.4791 48.0738 24.5001 43.9604C24.5163 40.7748 26.3063 39.1181 27.5 37.7654V17C27.5 14.5187 29.5188 12.5 32 12.5C34.4813 12.5 36.5 14.5187 36.5 17V37.7654C37.6841 39.1072 39.5 40.7808 39.5 44C39.5 48.1355 36.1355 51.5 32 51.5ZM38 44C38 47.3137 35.3137 50 32 50C28.6863 50 26 47.3137 26 44C26 41.7795 27.2072 39.8423 29 38.8047V17C29 15.3432 30.3432 14 32 14C33.6569 14 35 15.3432 35 17V38.8047C36.7929 39.8423 38 41.7795 38 44Z",
    fill: "url(#hinava_random_uuid_95724349888174206200772238633008055657)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_95724349888174206200772238633008055657",
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature4);
export default __webpack_public_path__ + "static/media/temperature-4.31d5410aee6c9b8fe8ca9007799a5bd5.svg";
export { ForwardRef as ReactComponent };